import React, { useState, useEffect } from "react";
import { Spinner, MrSelect } from "mr_react_framework";
import { useDispatch, useSelector } from "react-redux";
import {
  appRegionSelector,
  currentUserSelector,
} from "views/Auth/Login/selector";
import { checkMob, displayPoints } from "lib/utils/helperMethods";
import { Col, Radio, Row, Space, Switch, Table, Tabs, Tag, Tooltip } from "antd";
import { actions as experienceActions } from "views/Experiences/redux";
import { gradebookAnalyticsSelector } from "views/Experiences/selector";
import MrTranslate, { useTranslate } from "lib/MrTranslate/MrTranslate";

const ExperiencesStudentsGrid = (props) => {
  const { data, viewBy } = props;
  const all_mapped_and_submitted_students = data.all_mapped_and_submitted_students;
  const experiences = data.experiences;
  const experiences_submissions_data = data.experiences_submissions_data;
  const standards = data.standards;
  const standards_performance_data = data.standards_performance_data;
  const mrIntl = useTranslate()
  const [gridRows, setGridRows] = useState([]);
  const [gridColumns, setGridColumns] = useState([]);
  let finalRender = []

  useEffect(() => {
    let rows = [];
    let columns = [];
    if (viewBy === "standards") {
      columns[0] = {
        title: "Standards",
        dataIndex: "name",
        key: "name",
        width: 150,
        fixed: "left",
        // ellipsis: {
        //   showTitle: true,
        // },
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: ['ascend', 'descend'],
        defaultSorter: 'ascend'
      };
      columns[1] = {
        title: "Distribution",
        dataIndex: "distribution",
        key: "distribution",
        width: 350,
        fixed: "left",
        // ellipsis: {
        //   showTitle: true,
        // },
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: ['ascend', 'descend'],
        defaultSorter: 'ascend'
      };

      // TODO: show standards here but when propoerly filtered
      standards_performance_data.forEach((s, i) => {
        let row = {}
        // let userId = u[0]
        // let name = u[1]
        row.id = s.tag_id
        row.name = (
          <span>
            {s.label}
          </span>
        );
        row.distribution = (
          <div style={{width: "500px", display: "flex"}}>
            {/* {JSON.stringify(s.distribution)} */}
            {s.distribution.map((obj) => {
              if(obj.label !== "Ungraded" && obj.label !== "Unattempted"){
                return <Tooltip title={obj.label.concat(" - ").concat(obj.percentage).concat("%")}><div style={{width: `${obj.percentage}%`, backgroundColor: obj.color, height: "30px"}}></div></Tooltip>
              }
            })}
          </div>
        )

        rows.push(row);
      });

    } else {
      columns[0] = {
        // title: "Students ("+all_mapped_and_submitted_students.length+")",
        title: mrIntl("Gradebook.all_mapped_and_submit_student", {allMappedAndSubmitStudent: all_mapped_and_submitted_students.length}),
        dataIndex: "name",
        key: "name",
        width: 150,
        fixed: "left",
        // ellipsis: {
        //   showTitle: true,
        // },
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: ['ascend', 'descend'],
        defaultSorter: 'ascend'
      };
      // columns[1] = {
      //   title: "Avg. %",
      //   dataIndex: "average_percentage",
      //   key: "average_percentage",
      //   width: 100,
      //   sorter: (a, b) => a.average_percentage - b.average_percentage,
      //   sortDirections: ["ascend", "descend"],
      //   defaultSorter: "ascend",
      // };
      all_mapped_and_submitted_students.forEach((u, i) => {
        let row = {}
        // let userId = u[0]
        // let name = u[1]
        row.id = u.id
        row.name = (
          <span
            // style={{ cursor: "pointer" }}
            // onClick={() => {
            //   setSelectedExperienceUser(u.id);
            //   setShowGradingGridModal(false);
            // }}
          >
            {u.name}
          </span>
        );
        // row.average_percentage = (
        //   <span>{displayPoints((eu.points*100)/eu.custom_fields.experience_points)}%</span>
        // );
        
        if (experiences) {
          experiences.forEach((e, j) => {
            if (i == 0) {
              columns.push({
                title: (
                  // <Space direction={"vertical"}>
                    <span>{e.name.substring(0,6).concat("..")}</span>
                  //   <span>
                  //     ({displayPoints(segment.points, false, true)})
                  //   </span>
                  // </Space>
                ),
                dataIndex: j,
                key: "column-"+j,
                width: 100,
                sorter: (a, b) => a.j - b.j,
                sortDirections: ["ascend", "descend"],
                defaultSorter: "ascend",
              });
            }
  
            let euData = experiences_submissions_data.find((eu) => eu.experience_id === e.id && eu.user_id === u.id);
            if (euData) {
              let eu = euData.eu;
              if(eu){
                let euPercentage = displayPoints((eu.points*100)/eu.custom_fields.experience_points); // TODO percentage
                row[j] = (
                  <span>
                    {euPercentage}%
                  </span>
                );
              }else{
                // absent
                row[j] = (
                  <span>
                    <MrTranslate id={"Gradebook.absent"}/>
                  </span>
                );
              }
            }else{
              // Not mapped
              row[j] = "-"
            }
          });
        } else if (standards) {
          standards.forEach((s, j) => {
            if (i == 0) {
              columns.push({
                title: (
                  // <Space direction={"vertical"}>
                    <span>{s.label.substring(0,6)}</span>
                  //   <span>
                  //     ({displayPoints(segment.points, false, true)})
                  //   </span>
                  // </Space>
                ),
                dataIndex: j,
                key: "column-"+j,
                width: 100,
                sorter: (a, b) => a.j - b.j,
                sortDirections: ["ascend", "descend"],
                defaultSorter: "ascend",
              });
            }
  
            let standardsData = standards_performance_data.find((obj) => obj.tag_id === s.tag_id && obj.user_id === u.id);
            if (standardsData) {
              // let eu = euData.eu;
              // if(eu){
                // let euPercentage = displayPoints((eu.points*100)/eu.custom_fields.experience_points); // TODO percentage
                row[j] = (
                  <span>
                    {standardsData.average_percentage}%
                    <br></br>
                    {standardsData.proficiency_level && <Tag color={standardsData.proficiency_level.color}>{standardsData.proficiency_level.label}</Tag>}
                  </span>
                );
              // }else{
              //   // absent
              //   row[j] = (
              //     <span>
              //       <MrTranslate id={"Gradebook.absent"}/>
              //     </span>
              //   );
              // }
            }else{
              // Not mapped
              row[j] = "-"
            }
          });
        }
        rows.push(row);
      });
    }

    console.log("GradingGrid rows columns", rows, columns);
    setGridRows(rows);
    setGridColumns(columns);
  }, [ experiences, experiences_submissions_data, all_mapped_and_submitted_students, standards, standards_performance_data ]);

  let tableRender = <Table
    // className={"grading-ggrid"}
    dataSource={gridRows}
    columns={gridColumns}
    pagination={false}
    // size="small"
    showHeader={true}
    scroll={{ x: 800, y: 500 }}
  />
  
  finalRender.push(tableRender)
  return finalRender;
}

const Gradebook = (props) => {
  console.log("Gradebook props ==>", props);
  // const {  } = props;
  const dispatch = useDispatch();
  const [viewBy, setViewBy] = useState("students_vs_experiences");
  const currentUser = useSelector(currentUserSelector());
  const gradebookAnalyticsData = useSelector(gradebookAnalyticsSelector());

  useEffect(() => {
    dispatch(experienceActions.getAnalytics({type: "gradebook", view_by: viewBy, with_proficiency_levels: viewBy === "standards" ? true : false}))
    return () => {
    };
  }, [viewBy]);

  console.log("Gradebook gradebookAnalyticsData ", gradebookAnalyticsData);

 
  return (
    <React.Fragment>
      <Row>
        <Col span={22} offset={1} className="m-b-10 text-right">
          <Radio.Group defaultValue="students_vs_experiences" buttonStyle="solid" onChange={(e) => { 
            console.log("e.target.value", e.target.value);
            setViewBy(e.target.value);
          }}>
            <Radio.Button value="students_vs_experiences">Students & Assessments</Radio.Button>
            <Radio.Button value="students_vs_standards">Students & Standards</Radio.Button>
            <Radio.Button value="standards">Standards</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
      <Row>
        <Col span={22} offset={1}>
          {gradebookAnalyticsData.grid_data && <ExperiencesStudentsGrid data={gradebookAnalyticsData.grid_data} viewBy={viewBy}/>}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Gradebook;
